import * as effects from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { api } from '@REST/api';
import { handleError } from '@bus/ui/saga/workers/handleError';
import { throwError } from '@bus/ui/saga/workers/throwError';

import { aiConversationActions } from '../../actions';
import {
  LoadMoreMessagesActionPayload,
  PushMoreMessagesActionPayload,
} from '../../typedefs';

export function* loadMoreMessages({
  payload,
}: PayloadAction<LoadMoreMessagesActionPayload>) {
  try {
    yield effects.put(aiConversationActions.startFetching());
    const response: Response = yield effects.apply(api, api.get, [
      { endpoint: payload.url, direct: true, unsafe: true },
    ]);
    if (!response.ok) {
      yield throwError(response);
    }
    const data: PushMoreMessagesActionPayload = yield effects.call([
      response,
      'json',
    ]);
    yield effects.put(
      aiConversationActions.pushMoreMessages({
        data,
        sessionId: payload.sessionId,
      }),
    );
  } catch (e) {
    yield handleError(e);
  } finally {
    yield effects.put(aiConversationActions.stopFetching());
  }
}
